import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Section.module.scss'

const TitleWrapper = createDivAtom()

const Section = props => (
  <main className={styles.section}>
    {props.title && (
      <TitleWrapper className={classNames(
        styles.title,
        props?.align === 'left' && styles.alignLeftTitle
      )}>
        {props.title}
      </TitleWrapper>
    )}

    {props?.children}
  </main>
)

Section.propTypes = {
  title: PropTypes.string,
  align: PropTypes.string,
  children: PropTypes.any
}

export default Section
